export enum CompanyConfigurationKey {
  ACTIVITY_REPORT_ENABLED = 'ACTIVITY_REPORT_ENABLED',
  ALLOW_USERS_WITHOUT_EMAILS = 'ALLOW_USERS_WITHOUT_EMAILS',
  BAMBOOHR_EMPLOYMENT_STATUS_FILTER = 'BAMBOOHR_EMPLOYMENT_STATUS_FILTER',
  CHARTHOP_EMPLOYMENT_STATUS_FILTER = 'CHARTHOP_EMPLOYMENT_STATUS_FILTER',
  CLIENT_API_WEBHOOKS_ENABLED = 'CLIENT_API_WEBHOOKS_ENABLED',
  CUSTOM_CONTENT_AUTHORSHIP = 'CUSTOM_CONTENT_AUTHORSHIP',
  CUSTOM_COURSE_CONTACT_EMAIL = 'CUSTOM_COURSE_CONTACT_EMAIL',
  CUSTOM_COURSE_IMPORT = 'CUSTOM_COURSE_IMPORT',
  CUSTOM_EMAIL_FROM_PREFIX = 'CUSTOM_EMAIL_FROM_PREFIX',
  CUSTOM_QUESTIONS_EMAIL = 'CUSTOM_QUESTIONS_EMAIL',
  CUSTOM_TECHNICAL_SUPPORT_EMAIL = 'CUSTOM_TECHNICAL_SUPPORT_EMAIL',
  DEMO_ACCOUNT = 'DEMO_ACCOUNT',
  DISABLE_NOTIFICATIONS = 'DISABLE_NOTIFICATIONS',
  ENROLLABLE_COURSE_IDS = 'ENROLLABLE_COURSE_IDS',
  ENTERPRISE_ACCOUNT = 'ENTERPRISE_ACCOUNT',
  HIDDEN_USER_SETTINGS = 'HIDDEN_USER_SETTINGS',
  HIDE_TIMER_DISCLAIMER_SLIDE = 'HIDE_TIMER_DISCLAIMER_SLIDE',
  LEARNER_LANGUAGES = 'LEARNER_LANGUAGES',
  LEARNING_CENTER_BRANDING_THEME_ID = 'LEARNING_CENTER_BRANDING_THEME_ID',
  LOOKER_DASHBOARD_IDS = 'LOOKER_DASHBOARD_IDS',
  MISCONDUCT_REPORTING_ADMIN_NOTE_PEOPLE_REPORTED = 'MISCONDUCT_REPORTING_ADMIN_NOTE_PEOPLE_REPORTED',
  MISCONDUCT_REPORTING_ADMIN_NOTE_PROCESS = 'MISCONDUCT_REPORTING_ADMIN_NOTE_PROCESS',
  MISCONDUCT_REPORTING_ADMIN_NOTE_TIMELINE = 'MISCONDUCT_REPORTING_ADMIN_NOTE_TIMELINE',
  MISCONDUCT_REPORTING_CASE_MANAGEMENT_ENABLED = 'MISCONDUCT_REPORTING_CASE_MANAGEMENT_ENABLED',
  MISCONDUCT_REPORTING_ENABLED = 'MISCONDUCT_REPORTING_ENABLED',
  MISCONDUCT_REPORTING_PHONE_LINE_COUNTRIES = 'MISCONDUCT_REPORTING_PHONE_LINE_COUNTRIES',
  MISCONDUCT_REPORTING_PHONE_LINE_ENABLED = 'MISCONDUCT_REPORTING_PHONE_LINE_ENABLED',
  MULTIPLE_ETHENA_CAMPAIGNS_PER_COURSE_ENABLED = 'MULTIPLE_ETHENA_CAMPAIGNS_PER_COURSE_ENABLED',
  SCORM_HIDE_ETHENA_REFERENCES = 'SCORM_HIDE_ETHENA_REFERENCES',
  SCORM_HIDE_PII = 'SCORM_HIDE_PII',
  SCORM_HIDE_ROLE_AND_LOCATION_UPDATE = 'SCORM_HIDE_ROLE_AND_LOCATION_UPDATE',
  SCORM_MODE = 'SCORM_MODE',
  SSO_CONNECTION = 'SSO_CONNECTION',
  SSO_KIOSK_ENABLED = 'SSO_KIOSK_ENABLED',
  TRAINING_CENTER_BANNER_TEXT = 'TRAINING_CENTER_BANNER_TEXT',
  UNLIMITED_COURSE_BUNDLE_ENABLED = 'UNLIMITED_COURSE_BUNDLE_ENABLED',
  WORKDAY_ENROLLMENT_COURSE_IDS = 'WORKDAY_ENROLLMENT_COURSE_IDS',
}

export enum ScormMode {
  DISABLED = 'DISABLED',
  SCORM_ADD_ON = 'SCORM_ADD_ON',
  SCORM_ONLY = 'SCORM_ONLY',
}

export interface IAdminCompanyConfiguration {
  key: CompanyConfigurationKey;
  type: string;
  default: unknown;
  value?: string;
}

export interface ICompanyConfigurations {
  bambooHrEmploymentStatusFilter: string[];
  charthopEmploymentStatusFilter: string[];
  companyId: number;
  customEmailFromPrefix?: string;
  customQuestionsEmail?: string;
  enrollableCourseIds: number[];
  learnerLanguages: string[];
  learningCenterBrandingThemeId?: number;
  lookerDashboardIds: number[];
  ssoConnection?: string;
  trainingCenterBannerText: string;
  isDemoAccount: boolean;
  disableNotifications: boolean;
  isActivityReportEnabled: boolean;
  isCustomCourseImportEnabled: boolean;
  customCourseContactEmail?: string;
  workdayEnrollmentCourseIds: number[];
  isEnterpriseAccount: boolean;
  isUnlimitedCourseBundleEnabled: boolean;
  isMisconductReportingEnabled: boolean;
  isMisconductReportingCaseManagementEnabled: boolean;
  misconductReportingAdminNotePeopleReported?: string;
  misconductReportingAdminNoteProcess?: string;
  misconductReportingAdminNoteTimeline?: string;
}
